import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CommonPage } from './common.page';
import { AddFieldComponent } from './components/add-field/add-field.component';
import { DeviceLocationComponent } from './components/device-location/device-location.component';
import { DeviceUpdateComponent } from './components/device-update/device-update.component';
import { EnterDeviceComponent } from './components/enter-device/enter-device.component';
import { FarmDeviceDetailComponent } from './components/farm-device-detail/farm-device-detail.component';
import { LaterPageComponent } from './components/later-page/later-page.component';
import { NotificationListComponent } from './components/notification-list/notification-list.component';
import { PickDeviceTypePairComponent } from './components/pick-device-type-pair/pick-device-type-pair.component';
import { PickDeviceTypeComponent } from './components/pick-device-type/pick-device-type.component';
import { DeviceDetailComponent } from './profile/components/device-detail/device-detail.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'pick-device',
        component: PickDeviceTypeComponent
      },
      {
        path: 'pair-device',
        component: PickDeviceTypePairComponent
      },
      {
        path: 'enter-device',
        component: EnterDeviceComponent
      },
      {
        path: 'later-page',
        component: LaterPageComponent
      },
      {
        path: 'add-field',
        component: AddFieldComponent
      },
      {
        path: 'detail',
        children: [
          {
            path: '',
            component: FarmDeviceDetailComponent,

          },
          {
            path: 'device-update',
            component: DeviceUpdateComponent
          }],
      },

      {
        path: 'weather-forecast',
        loadChildren: () => import('./weather-forecast/weather-forecast.module').then(m => m.WeatherForecastPageModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.module').then(m => m.ProfilePageModule)
      },
      {
        path: 'notification-list',
        component: NotificationListComponent
      },
      {
        path: 'device-location',
        component: DeviceLocationComponent
      },
      {
        path: '',
        redirectTo: '/common/pick-device',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    redirectTo: '/common/pick-device',
    pathMatch: 'full'
  },
  {
    path: 'weather-forecast',
    loadChildren: () => import('./weather-forecast/weather-forecast.module').then(m => m.WeatherForecastPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'farm-map',
    loadChildren: () => import('./farm-map/farm-map.module').then(m => m.FarmMapPageModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)]
})
export class CommonPageRoutingModule { }
